<script setup>
import { useRouter } from 'vue-router';
import { url } from '@/config/urls';
import { openPdfViewerOrNewTab } from '@functions/pdf.js';

const router = useRouter();

// コンポーネントに渡されたpropsの取得
const props = defineProps({
  topPageUrl: {type: String, default: url.page.top},
  aboutPageUrl: {type: String, default: url.page.other.about},
  questionsPageUrl: {type: String, default: url.page.other.questions},
  termsPageUrl: {type: String, default: url.page.other.terms},
  environmentPageUrl: {type: String, default: url.page.other.environment},
  companyPageUrl: {type: String, default: url.page.other.company},
});
</script>

<template>
  <footer id="footer1">
    <div class="com_inner1 clearfix">
      <div class="block1">
        <h2 class="logo1">
          <img src="/front/assets/common/img/logo2.png" alt="共創未来グループ">
        </h2>
        <ul class="list1">
          <li><a :href="props.companyPageUrl" target="_blank">会社案内</a></li>
          <li><a :href="props.aboutPageUrl" target="_blank" @click.prevent="openPdfViewerOrNewTab(router, '/pdf-viewer/manual', props.aboutPageUrl)">
            マニュアル
            <img src="/front/assets/common/img/icon_pdf2.png" alt="PDF" class="com_icon_pdf1">
          </a></li>
          <li><a :href="props.environmentPageUrl" target="_blank" @click.prevent="openPdfViewerOrNewTab(router, '/pdf-viewer/environment', props.environmentPageUrl)">
            サイトの利用環境
            <img src="/front/assets/common/img/icon_pdf2.png" alt="PDF" class="com_icon_pdf1">
          </a></li>
          <li><a :href="props.termsPageUrl" target="_blank" @click.prevent="openPdfViewerOrNewTab(router, '/pdf-viewer/terms', props.termsPageUrl)">
            利用規約
            <img src="/front/assets/common/img/icon_pdf2.png" alt="PDF" class="com_icon_pdf1">
          </a></li>
          <li><a :href="props.questionsPageUrl" target="_blank">困ったときのQ&A</a></li>
        </ul>
      </div>
      <p class="copyright1">Copyright &copy; TOHO HOLDINGS CO., LTD.</p>
    </div>
  </footer>
</template>

<style scope>
.com_inner1 {
  max-width: 980px !important;
}
</style>